import { put, select, debounce } from "redux-saga/effects";
import * as filtersActions from "../actions/filters";
import * as vehiclesActions from "../actions/vehiclesActions";

function* updateFilterFieldsSaga() {
  const filters = yield select(state => state.Transport.Vehicles.filters);
  let countFilters = 0;

  if (filters.search && filters.search.length > 1) {
    countFilters++;
  }
  if (filters.fields) {
    countFilters += Object.keys(filters.fields).length;
  }
  if (filters.count !== countFilters) {
    yield put(filtersActions.countFiltersVehicles(countFilters));
  }

  yield put(vehiclesActions.getFilterVehicles(filters));
}

export function* filtersConfigWatcher() {
  yield debounce(
    600,
    [
      filtersActions.updateFilterFieldsVehicles.toString(),
      filtersActions.searchVehicles.toString()
    ],
    updateFilterFieldsSaga
  );
}
